import styles from "../../../styles/Components/alert-system/alert-strategy/StrategyItem.module.css";
import {
  FaBolt,
  FaCalendarCheck,
  FaChartLine,
  FaComments,
  FaCube,
  FaPuzzlePiece,
  FaRegClock,
  FaRegNewspaper,
  FaWallet,
} from "react-icons/fa6";
import { AiOutlineLineChart, AiOutlineSafety } from "react-icons/ai";
import {
  MdGraphicEq,
  MdNetworkCheck,
  MdOutlineLocationOn,
  MdOutlineMood,
  MdOutlinePsychology,
  MdOutlineSecurity,
  MdRemoveCircleOutline,
  MdShowChart,
  MdTimeline,
} from "react-icons/md";
import { FiVolume2 } from "react-icons/fi";
import { TbWaveSine } from "react-icons/tb";
import { HiOutlineChartSquareBar } from "react-icons/hi";
import {
  FaBalanceScale,
  FaBitcoin,
  FaCalendarAlt,
  FaExclamationTriangle,
  FaMoneyBillWave,
  FaRegListAlt,
  FaRobot,
  FaUniversity,
} from "react-icons/fa";
import { GiMetalBar, GiPerspectiveDiceSixFacesFour } from "react-icons/gi";
import { BsLightning, BsStars } from "react-icons/bs";
import { getRelativeTime } from "../../../utility/formatter-helper";
import { HiOutlineSparkles } from "react-icons/hi2";
import { BiScatterChart, BiSolidCustomize } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import {
  deleteAlertStrategy,
  updateAlertStrategy,
} from "../../../redux/alert-system/actions";
import { useRef } from "react";

const strategyIcons = {
  Momentum: <FaBolt />,
  "Mean Reversion": <AiOutlineLineChart />,
  Spot: <MdOutlineLocationOn />,
  Future: <FaRegClock />,
  Trend: <FaChartLine />,
  Volume: <FiVolume2 />,
  Volatility: <TbWaveSine />,
  "Social Sentiment": <FaComments />,
  "Technical Indicators": <HiOutlineChartSquareBar />,
  "Fundamental Analysis": <FaUniversity />,
  "Blockchain Data": <FaCube />,
  "High Risk": <FaExclamationTriangle />,
  "Moderate Risk": <GiPerspectiveDiceSixFacesFour />,
  "Low Risk": <AiOutlineSafety />,
  "Risk-Neutral": <MdRemoveCircleOutline />,
  "Short Term": <BsLightning />,
  "Medium Term": <MdTimeline />,
  "Long Term": <FaCalendarAlt />,
  Cryptocurrency: <FaBitcoin />,
  Stocks: <FaChartLine />,
  Forex: <FaMoneyBillWave />,
  Commodities: <GiMetalBar />,
  "Network activity": <MdNetworkCheck />,
  "Wallet Data": <FaWallet />,
  "AI Powered": <FaRobot />,
};

const strategyTagIcons = {
  "News Sentiment": <FaRegNewspaper />,
  "Social Media Sentiment": <HiOutlineSparkles />,
  "Volume Trends": <MdGraphicEq />,
  "Volatility Index": <BiScatterChart />,
  "Market Mood Analysis": <MdOutlineMood />,
  "Emotional Tone Detection": <MdOutlinePsychology />,
  "Pattern Analysis": <MdShowChart />,
  "Portfolio Balancing": <FaBalanceScale />,
  "Risk Mitigation": <MdOutlineSecurity />,
  "High-Frequency Algorithms": <FaRobot />,
  "Sentiment Rating": <BsStars />,
  Predefined: <FaRegListAlt />,
};

function StrategyItem({ data = {} }) {
  const {
    alertSystem: {
      alertStrategies,
      updateStrategiesStatus,
      deleteStrategyStatus,
    },
    main: { userData },
  } = useSelector((state) => state);

  const targetStrategy = useRef(null);

  const {
    createdDate,
    list_feature_info: featuresList,
    // market_type: marketType,
    strategy_label: label,
    strategy_name: name,
    strategy_tag: tag,
  } = data;

  const dispatch = useDispatch();

  const showLoading =
    (updateStrategiesStatus === "loading" ||
      deleteStrategyStatus === "loading") &&
    targetStrategy.current === createdDate;

  const isAlertStrategyActive = alertStrategies?.includes(createdDate);

  const manageStrategyAlert = () => {
    if (showLoading) return;

    const strategies =
      typeof alertStrategies === "string"
        ? JSON.parse(alertStrategies.replace(/'/g, '"'))
        : alertStrategies;

    const strategyList = isAlertStrategyActive
      ? strategies?.filter((strategyId) => strategyId !== createdDate)
      : [...strategies, createdDate];

    targetStrategy.current = createdDate;

    const useDelete = strategies.length === 1 && strategyList.length === 1;

    if (useDelete) {
      dispatch(
        deleteAlertStrategy(
          userData?.["custom:custom_username"],
          userData?.["cognito:username"],
        ),
      ).then(() => {
        targetStrategy.current = null;
      });
    } else {
      dispatch(
        updateAlertStrategy(
          userData?.["custom:custom_username"],
          userData?.["cognito:username"],
          [...strategyList],
        ),
      ).then(() => {
        targetStrategy.current = null;
      });
    }
  };

  return (
    <div
      className={`${styles.container} ${isAlertStrategyActive ? styles.active : ""}`}
    >
      {isAlertStrategyActive && (
        <span className={styles.activeBadge}>Active</span>
      )}
      <div className={styles.title}>
        {/*{strategyIcons?.[label] || ""}*/}
        <h4>{name}</h4>
      </div>
      <div className={styles.strategyInfo}>
        <FaPuzzlePiece />
        <span>
          Features:{"  "}
          {featuresList?.length}
        </span>
      </div>
      <div className={styles.strategyInfo}>
        <FaCalendarCheck />
        <span>
          Created:{"  "}
          {getRelativeTime(createdDate)}
        </span>
      </div>
      {label && (
        <div className={styles.strategyTag}>
          {strategyIcons?.[label] || <BiSolidCustomize />}
          <span>{label}</span>
        </div>
      )}
      {tag && (
        <div className={styles.strategyTag}>
          {strategyTagIcons?.[tag] || <BiSolidCustomize />}
          <span>{tag}</span>
        </div>
      )}

      <div className={styles.footer}>
        <Button
          className={`${styles.btn} ${!isAlertStrategyActive ? styles.activateBtn : styles.deactivateBtn}`}
          onClick={manageStrategyAlert}
          loading={showLoading}
        >
          {!isAlertStrategyActive ? "Activate" : "Deactivate"}
        </Button>
      </div>
    </div>
  );
}

export default StrategyItem;
